import { render, staticRenderFns } from "./ReleasesByCategory.vue?vue&type=template&id=a551fd8c&scoped=true&"
import script from "./ReleasesByCategory.vue?vue&type=script&lang=js&"
export * from "./ReleasesByCategory.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesByCategory.vue?vue&type=style&index=0&id=a551fd8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a551fd8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
